import { iShopifyShop } from "../types/internal";

/** shop-team:setup-local demo shop — skip Shopify OAuth re-auth on localhost only. */
export const LOCAL_DEV_SHOP_DOMAIN = "local-test.myshopify.com";
export const LOCAL_DEV_CUSTOMER_UID = "6a93edb5a5c7f";

export function shouldSkipShopifyReauthOnLocalhost(shop: iShopifyShop): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1") {
        return false;
    }

    return (
        shop.myshopify_domain === LOCAL_DEV_SHOP_DOMAIN ||
        shop.customer_uid === LOCAL_DEV_CUSTOMER_UID
    );
}
